//src/services/adminCustomers.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminCustomers = () => {
  return adminApiRequest("/admin/customers");
};

export const getAdminCustomerById = (id) => {
  return adminApiRequest(`/admin/customers/${id}`);
};

export const toggleAdminCustomerStatus = (id) => {
  return adminApiRequest(`/admin/customers/${id}/toggle`, {
    method: "PUT",
  });
};
